module.exports = __webpack_public_path__ + "static/media/sideBarHorse.6c8a9ff3.svg";